import { getAppLocale } from '../../../utils/app-locale';
import { api_base_url } from '../../../constants';
import { API_INSTANCE } from '../../../utils/service-http';
import { appConfiguration } from '../../../utils/app-starter';

export function getLicenceSelectorSoftwares () {

  return async (dispatch, getState) => {

    const payload = {};

    const rangesToScope = getState().callByRangeReducer?.selectedItems.ranges ? Object.keys(getState().callByRangeReducer?.selectedItems.ranges) : [];
    const referencesToScope = getState().callByRangeReducer?.selectedItems.references ? Object.keys(getState().callByRangeReducer?.selectedItems.references) : [];

    const mainOverrideString = appConfiguration.main ? `&main=${appConfiguration.main}` : '';

    if (rangesToScope.length > 0) {
      payload.scopedCategories = rangesToScope;
    }

    if (referencesToScope.length > 0) {
      payload.scopedReferences = referencesToScope;
    }

    return API_INSTANCE.post(`${api_base_url}/licence-selector-softwares?locale=${getAppLocale()}${mainOverrideString}`, payload).then((success) => {
      return success.data.payload;
    }).catch((error) => {
      throw error;
    });
  };
}
